export const numeroRelativoRegExp = /\d+(\.\d+){0,2}/g;
export const replaceSubitemRegExp = /(\d+)\.(\d+)(?:\.(\d+))?/;
export const paisRegExp = /.*?([A-Z][A-Z]).*?/g;
